import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from '../../../config/config.service';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { handleProblem } from '../../problems/problem.service';
import { TaskProtectedValueCreateInterface } from '../definitions/task-protected-value-create-interface';
import { TaskProtectedValueCreateRequestInterface } from '../definitions/task-protected-value-create-request-interface';

@Injectable()
export class TaskProtectedValueCreateService {
  public constructor(private client: HttpClient, private configService: ConfigService) {}

  public create(taskId: string, data: TaskProtectedValueCreateRequestInterface): Observable<TaskProtectedValueCreateInterface> {
    const url = `${this.configService.config.rest.apiV2Url}/tasks/${taskId}/protected-values`;

    return this.client.post<TaskProtectedValueCreateInterface>(url, data).pipe(
      catchError(error => throwError(handleProblem(error)))
    );
  }
}